// removed by extract-text-webpack-plugin
module.exports = {"flexContainer":"Carousel__flexContainer___7iQZI","carouselHeader":"Carousel__carouselHeader___1ED6Q","mainCarouselBody":"Carousel__mainCarouselBody____5Zd1","carouselFooter":"Carousel__carouselFooter___3OYBy"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Carousel/Carousel.css
// module id = 1009
// module chunks = 0